// @generated by TypeGen from LogbookApp/AppState.swift - DO NOT EDIT

export interface ILogbookAppNMEAConfiguration {
  type: ILogbookNMEAProtocol;
  host?: string;
  port?: number;
  device?: string;
  baudRate?: number;
}

export interface ILocalShip {
  id: number;
  accountId: number;
  name: string;
  type: string;
  domain: string;
  ip?: string;
  port: number;
  proto: string;
}

export enum ILogbookNMEAProtocol {
  tcp = "tcp",
  udp = "udp",
  bluetooth = "bluetooth",
  usb = "usb",
  gps = "gps",
}
